import type {SessionQuestion} from './sessionQuestion/sessionQuestionSchema';
import {QuizSessionState} from './QuizSessionState';
import {isSessionQuestionAnswered} from './sessionQuestion/isSessionQuestionAnswered';

export interface QuizSessionEndUpdate {
  questions: SessionQuestion[];
  endedAt: Date;
  state: QuizSessionState.COMPLETED;
}

/**
 * Produces the payload to close/end a quiz session: all unanswered questions
 * are marked as answered with empty string and isCorrect false, endedAt is set, and state set to COMPLETED.
 * Use when the user ends the session early or when all questions are answered.
 */
export function createQuizSessionEndUpdate(questions: SessionQuestion[]): QuizSessionEndUpdate {
  const endedQuestions: SessionQuestion[] = questions.map((q) =>
    isSessionQuestionAnswered(q) ? q : {...q, selectedAnswer: '', isCorrect: false},
  );
  return {
    questions: endedQuestions,
    endedAt: new Date(),
    state: QuizSessionState.COMPLETED,
  };
}
